const $getSameDayTitles = () => document.querySelectorAll(".js-qty-row-same-day-title");
const $getSameDayVariants = () => document.querySelectorAll(".js-qty-row-same-day-stock");

const hideSameDayInfo = () => {
  $getSameDayTitles().forEach(el => el.classList.add("hidden"));
  $getSameDayVariants().forEach(el => el.classList.add("hidden"));
};

const updateFlashStock = () => {
  hideSameDayInfo();
};

export default updateFlashStock;
